import React from 'react';
import useModalStore from '../../store/useModalStore';

export const Close = ({
  className,
  onClick
}: {
  className?: string;
  onClick: () => void;
}) => (
  <svg
    onClick={onClick}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`relative top-10 left-2 cursor-pointer ${className}`}
  >
    <circle cx="12" cy="12" r="12" fill="white" fill-opacity="0.75" />
    <path
      d="M15.5 7.75L8.5 15.25"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 7.75L15.5 15.25"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
